import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useImageBackgroundSectionStyles = makeStyles({
  subHeading: {
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 600,
    lineHeight: '26px',
    fontFamily: 'Segoe UI',
    fontSize: '20px',
    textAlign: 'left',
    marginTop: '20px',
  },
  paragraph: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'left',
  },
  backgroundCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    marginBottom: '30px',
    ...shorthands.overflow('hidden'),
  },
  uploadCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '247px',
    height: '247px',
    marginRight: '16px',
    ...shorthands.borderRadius('8px'),
    ...shorthands.border('1px', 'dashed', tokens.colorNeutralStroke1),
    ...shorthands.padding(0, '48px'),
    flexShrink: 0,
  },
  uploadIcon: {
    marginTop: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadFrame: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  uploadCaption: {
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textAlign: 'center',
    marginBottom: '10px',
  },
  uploadButton: {
    marginTop: 'auto',
    textAlign: 'center',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    marginBottom: '20px',
    ...shorthands.borderRadius('4px'),
    ...shorthands.padding('5px', '12px'),
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
  },
  imageCard: {
    display: 'flex',
    flexDirection: 'column',
    width: '247px',
    height: '247px',
    marginRight: '16px',
    justifyContent: 'center',
    alignItems: 'center',
    ...shorthands.borderRadius('8px'),
    ...shorthands.overflow('hidden'),
    flexShrink: 0,
  },
  image: {
    width: '247px',
    height: '247px',
    objectFit: 'cover',
  },
});
